<div id="auth-layout-hero">
	<ng-content select="[hero]"></ng-content>
</div>
<div id="auth-layout-form">
	<div id="form-content">
		<ng-content select="[form]"></ng-content>
	</div>
	<ng-content select="[buttons]"></ng-content>
</div>
